import cn from 'classnames';

const Stepper = ({ step, steps }: { step: number, steps: string[] }) => {
  return <div className='text-center flex flex-col justify-center items-center gap-2 mb-8'>
    <div>{step} / {steps.length}</div>
    <div className="flex flex-row gap-2">
      {steps.map((stepLabel, i) => <div key={i} className={cn(i === step - 1 ? 'border-t-premium-900' : 'border-t-gray-200', 'w-[150px] lg:w-[250px] border-t-2 ')}>
        {stepLabel}
      </div>)}
    </div>
  </div>
}

export default Stepper;